import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "validation-rules",
  "use": "validation-rules-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"validation-rules\"><path fill-rule=\"evenodd\" d=\"M2 10v2h12v-2H2Zm0-4v2h12V6H2Zm8 10v-2H2v2h8Zm13-3-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5L23 13Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol